import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LeadsComponent} from './leads.component';
import {LeadDetailComponent} from './lead-detail/lead-detail.component';

const routes: Routes = [
    {
        path: 'ask-expert-professional',
        component: LeadsComponent,
        data: {animation: 'ask-expert-professional'}
    },
    {
        path: 'ask-expert-professional/:id',
        component: LeadDetailComponent,
        data: {animation: 'ask-expert-professional/:id'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LeadsRoutingModule {
}
